import { useFormContext } from "react-hook-form";
import { formatarMonetárioParaNúmero, formatarValorMonetario } from "../../../../../../../../helpers/masks";
import { Box, FormControl, FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import { useMemo } from "react";
import { usePermission } from "../../../../../../../../components/PermissionGuard";

export default function AlertMarcarDesconto() {
    const { setValue, watch } = useFormContext();

    const totalAtt = watch('total_atualizado');
    const valorInputs = watch('finalizacao.recebimentos');
    const valueRadio = watch('finalizacao.aplicarDiferencaSemCupom');

    const permissaoDesconto = usePermission('financeiro.contas-receber-permitir-desconto')

    const { perguntarSobreDesconto, diffValor, precisaPermissao } = useMemo(() => {
        let totalValor = 0
        const params: TInternParams = {
            perguntarSobreDesconto: false,
            diffValor: 0,
            precisaPermissao: false,
        }
        if (valorInputs.length > 0) {
            totalValor = valorInputs.reduce((acumulador: number, item: any) =>
                acumulador + formatarMonetárioParaNúmero(item.valor), 0
            );
            totalValor = Math.round(totalValor * 100) / 100;
            params.perguntarSobreDesconto = totalValor < totalAtt ? true : false
            params.diffValor = totalAtt - totalValor
            params.precisaPermissao = (totalAtt - totalValor) > 0.99 ? true : false
        }

        return params
    }, [valorInputs, totalAtt])

    const handleChangeRadio = (value: boolean) => {
        setValue('finalizacao.aplicarDiferencaComoDesconto', value)
        setValue('finalizacao.aplicarDiferencaSemCupom', value)
        setValue('finalizacao.aplicarDiferencaComCupom', false)

    }

    const podeAplicarDesconto = useMemo(() => {
        return perguntarSobreDesconto && (!precisaPermissao || (precisaPermissao && permissaoDesconto));
    }, [perguntarSobreDesconto, precisaPermissao, permissaoDesconto])

    useMemo(() => {
        if(!podeAplicarDesconto) {setValue('finalizacao.aplicarDiferencaComoDesconto', false)}
    }, [podeAplicarDesconto, setValue])

    if (podeAplicarDesconto) return (
        <Box
            p={2}
            borderRadius={1}
            bgcolor="#fff4e5"
            sx={{ color: "#663c00" }}
            mt={2}
        >
            <Typography variant="subtitle2">
                A soma dos valores informados abaixo é menor que o total atualizado. Gostaria de aplicar o valor de <b>{formatarValorMonetario(diffValor)}</b> como um desconto e registrar recebimento total do(s) título(s)?
            </Typography>

            <FormControl>
                <RadioGroup
                    row
                    aria-labelledby="aplicar-como-desconto"
                    value={valueRadio}
                    onChange={(e) => handleChangeRadio(e.target.value as any)}
                >
                    <FormControlLabel value={true} control={<Radio color="warning" size="small" />} label="Sim" />
                    <FormControlLabel value={false} control={<Radio color="warning" size="small" />} label="Não" />
                </RadioGroup>
            </FormControl>
        </Box>
    )

    return (<></>)
}

type TInternParams = {
    perguntarSobreDesconto: boolean;
    diffValor: number;
    precisaPermissao: boolean;
}